import { formatReportMoney, reportCurrency } from '@evi/shared';

export function payoutPageTotals(rows: ReadonlyArray<{ breakdown: { currency?: string; gross_amount_cents?: number; owner_payout_cents?: number } }>) {
  const totals = new Map<string | null, { currency: string | null; gross_cents: number | null; owner_cents: number | null }>();
  for (const r of rows) {
    const currency = reportCurrency(r.breakdown.currency);
    const t = totals.get(currency) ?? { currency, gross_cents: currency ? 0 : null, owner_cents: currency ? 0 : null };
    if (currency) { t.gross_cents! += r.breakdown.gross_amount_cents ?? 0; t.owner_cents! += r.breakdown.owner_payout_cents ?? 0; }
    totals.set(currency, t);
  }
  return [...totals.values()].sort((a, b) => (a.currency ?? '').localeCompare(b.currency ?? ''));
}

export function payoutPageMoney(rows: ReturnType<typeof payoutPageTotals>, key: 'gross_cents' | 'owner_cents') {
  return rows.length ? rows.map(r => formatReportMoney(r[key], r.currency)).join(' · ') : 'No payments on page';
}

export function sessionPageAverage(rows: ReadonlyArray<{ cost?: { currency: string; total: number } }>) {
  const groups = new Map<string | null, { total: number; count: number }>();
  for (const r of rows) {
    const currency = reportCurrency(r.cost?.currency);
    const group = groups.get(currency) ?? { total: 0, count: 0 };
    group.total += r.cost?.total ?? 0; group.count++;
    groups.set(currency, group);
  }
  return [...groups].map(([currency, g]) => formatReportMoney(currency ? g.total / g.count : null, currency)).join(' · ') || 'No sessions on page';
}
